import { useState } from "react";

interface ExpandableSectionProps {
  title: string;
  preview?: string;
  children: React.ReactNode;
}

export function ExpandableSection({
  title,
  preview,
  children,
}: ExpandableSectionProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <details
      className="group rounded-4xl bg-black/5 dark:bg-white/5 p-4 [&_summary::-webkit-details-marker]:hidden"
      open={isOpen}
      onToggle={(e) => setIsOpen((e.target as HTMLDetailsElement).open)}
    >
      <summary className="flex cursor-pointer items-center justify-between gap-1.5">
        <div className="flex flex-col">
          <h2 className="text-lg font-bold text-content-light dark:text-content-dark">{title}</h2>
          {preview && !isOpen && (
            <p className="text-sm text-content-light/70 dark:text-content-dark/70">
              {preview} <span className="text-primary">Read more</span>
            </p>
          )}
        </div>
        <span className="material-symbols-outlined shrink-0 transition duration-300 group-open:-rotate-180 text-content-light dark:text-content-dark">
          expand_more
        </span>
      </summary>
      <div className="mt-4 space-y-3 leading-relaxed text-content-light/70 dark:text-content-dark/70">
        {children}
      </div>
    </details>
  );
}
